import { Pipe, PipeTransform } from '@angular/core';
import { dirname } from 'path';
/*
* Returns the dirname of a path
*/
@Pipe({name: 'dirname'})
export class DirnamePipe implements PipeTransform {
  transform(value: string): string {
    return dirname(value);
  }
}